

















import {ref, reactive, computed, defineComponent, PropType} from '@vue/composition-api'
import {shotStore, projectStore} from '@/store'

const props = {
}

export default defineComponent({
  name: 'ShotDuration',
  setup(props, context) {
    const shot = computed(() => projectStore.currentShot)

    const durationSec = computed(() => shot.value ? shot.value?.durationInSec : 1)

    function setDurationSec(newDuration: number) {
      newDuration = Math.max(0.1, Math.min(10, Number(newDuration)))
      if (shot.value && newDuration)
        shotStore.updateShotDuration({shot: shot.value, newDuration})
    }

    function required(val: any) {
      return val !== '' || 'Required'
    }
    function numeric(val: any) {
      return (Number(val) && Number(val) > 0) || 'Duration must be a positive number'
    }
    function notTooLong(val: any) {
      return Number(val) <= 10 || 'Videos limited to 10 sec max'
    }
    const bpSm = computed(() => context.root.$vuetify.breakpoint.smAndDown)
    const bpXs = computed(() => context.root.$vuetify.breakpoint.xs)

    return {durationSec, setDurationSec, required, numeric, notTooLong, bpSm, bpXs}
  }

})
